import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import {
	Icon,
	Url,
	TEXT_ALIGNMENT_OPTIONS,
	HERO_IMG_PLACEMENTS,
	HeroImagePlacements,
	TextAlignmentOptions,
} from '#const';
import { getIconUrl } from '#utils';

const CopyAndImage = dynamic(() => import('./CopyAndImage'));

Builder.registerComponent(CopyAndImage, {
	name: 'CopyAndImage',
	inputs: [
		{
			name: 'textSide',
			friendlyName: 'Text Side',
			type: 'string',
			enum: [...HERO_IMG_PLACEMENTS],
			defaultValue: HeroImagePlacements.LEFT,
			helperText: 'Which side of the section will the text fall?',
		},
		{
			name: 'heading',
			friendlyName: 'Heading Text',
			required: true,
			type: 'richText',
			defaultValue: '<h3>Copy and Image Section Heading</h3>',
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the heading.',
		},
		{
			name: 'headingSpan',
			friendlyName: 'Full Width Heading?',
			type: 'boolean',
			defaultValue: false,
			helperText: `Should the heading span between
			the text and image (true) or just span the width of the text (false)`,
		},
		{
			name: 'copy',
			friendlyName: 'Body Text',
			required: true,
			type: 'richText',
			defaultValue: '<p>lorem ipsum dolor sit</p>',
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Text Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the body text.',
		},
		{
			name: 'listColumns',
			friendlyName: 'List Columns',
			type: 'boolean',
			required: false,
			defaultValue: false,
			helperText: 'Should Ordered or Unordered Lists flow into two columns',
		},
		{
			name: 'image',
			required: false,
			friendlyName: 'Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			defaultValue: {
				src: Url.PLACEHOLDER,
				alt: '',
			},
		},
		{
			name: 'mobileImage',
			friendlyName: 'Mobile Image',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Should the Image appear on mobile?',
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
		},
		{
			name: 'line',
			friendlyName: 'Dividing Line',
			type: 'boolean',
			defaultValue: false,
			helperText: `Include dividing line under the headline?
				Color of line is set by the page secondary accent color.`,
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'Whats My Claim Worth',
					arrow: false,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
